//local dependencies
import { call } from "redux-saga/effects";
//loacal dependencies
import { apiRequest } from "../../../Utils/axiosApi";

export function* apiSendInvite() {
  try {
    const result = yield call(apiRequest, {
      method: "PUT",
      url: `/support/sendInvite`,
    });

    return result.isApiSuccessful
      ? result
      : { isApiSuccessful: false, data: null };
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSendFeedback(action) {
  try {
    const result = yield call(apiRequest, {
      method: "POST",
      url: `/support/feedback`,
      data: action.data,
    });

    return result.isApiSuccessful
      ? result
      : { isApiSuccessful: false, data: null };
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
